import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    windowInnerWidth: window.innerWidth,
    user: {
        id: '',
        name: '',
        email: '',
        // isAdmin: true,
        isAdmin: false,
    },
    isUploudingImage: false,
    selectedDate: null,
    isPreloader: false,
    timeSlots: [],
    selectedTime: null,
    selectedBookings: {},
    bookings: [],
    meetingSession: {},
    language: 'EN',
    cityGuides: [],
    showBookingIdAlert: false,
    userCoordinates: {
        lat: null,
        lon: null,
    },
    showMessageObj: {
        open: false,
        message: "", // '' || Array
        status: '',
    },
}

export const userSlice = createSlice({
    name: 'userSlice',
    initialState,
    reducers: {
        setWindowInnerWidth: (state, action) => {
            state.windowInnerWidth = action.payload;
        },
        setShowMessageObj: (state, action) => {
            state.showMessageObj = action.payload;
        },
        setUser: (state, action) => {
            state.user = action.payload;
        },
        setIsUploudingImage: (state, action) => {
            state.isUploudingImage = action.payload;
        },
        setSelectedDate: (state, action) => {
            state.selectedDate = action.payload;
        },
        setIsPreloader: (state, action) => {
            state.isPreloader = action.payload;
        },
        setTimeSlots: (state, action) => {
            state.timeSlots = action.payload;
        },
        setSelectedTime: (state, action) => {
            state.selectedTime = action.payload;
        },
        setSelectedBookings: (state, action) => {
            state.selectedBookings = action.payload;
        },
        setBookings: (state, action) => {
            state.bookings = action.payload;
        },
        setMeetingSession: (state, action) => {
            state.meetingSession = action.payload;
        },
        setLanguage: (state, action) => {
            state.language = action.payload;
        },
        setCityGuides: (state, action) => {
            state.cityGuides = action.payload;
        },
        setUserCoordinates: (state, action) => {
            state.userCoordinates = action.payload;
        },
        setShowBookingIdAlert: (state, action) => {
            state.showBookingIdAlert = action.payload;
        },
    },
})

export const { setShowBookingIdAlert, setUserCoordinates, setCityGuides, setLanguage, setMeetingSession, setBookings, setSelectedBookings, setSelectedTime, setTimeSlots, setIsPreloader, setSelectedDate, setIsUploudingImage, setUser, setWindowInnerWidth, setShowMessageObj } = userSlice.actions

export default userSlice.reducer